export default __webpack_public_path__ + "static/ai-marketing-1--mobile-4b33fbf5f3815082009aedd3244f19e4.png";